export default __webpack_public_path__ + "images/multilang-intro-step-1_2x.b600cc4ecc840e65b09cd1d37ba5a221.png";